import React from 'react';
import PropTypes from 'prop-types';

import '../../style/styles.scss';

const Cards = ({ description, nameCoach, descriptionCoach, imageCoach }) => (
  <div className="testimonials__card">
    <div className="testimonials__card__wrapper">
      <div className="testimonials__card__testimonials">
        “{description}”
      </div>
      <div className="testimonials__card__coach">
        <div className="testimonials__card__coach_photo">
          <img className="testimonials__card__coach_photo_photo" src={`images/testimonials/${imageCoach}`} alt={imageCoach} />
        </div>
        <div className="testimonials__card__coach_name">
          {nameCoach}
        </div>
        <div className="testimonials__card__coach_description">
          {descriptionCoach}
        </div>
      </div>
    </div>
  </div>
);

Cards.propTypes = {
  description: PropTypes.string.isRequired,
  nameCoach: PropTypes.string.isRequired,
  descriptionCoach: PropTypes.string.isRequired,
  imageCoach: PropTypes.string.isRequired,
};

export default Cards;
